import React from 'react';
import { Box } from '@mui/material';

import { HandsontableCommon } from '../common/handsontable-common';

import { ConfirmSectionTitle } from './confirm-title';

import type { PlanTableData } from '../common/handsontable.types';
import type { SearchOption } from '@/types/search';

interface DeleteSectionProps {
  tableData: PlanTableData;
  plantOptions: SearchOption[];
  witnessCompanyOptions: SearchOption[];
}

export const DeleteSection: React.FC<DeleteSectionProps> = ({
  tableData,
  plantOptions,
  witnessCompanyOptions,
}) => {
  if (tableData.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <ConfirmSectionTitle title='削除' count={tableData.length} color='#d32f2f' />
      <HandsontableCommon
        tableData={tableData}
        plantOptions={plantOptions}
        witnessCompanyOptions={witnessCompanyOptions}
        rowsWithErrors={[]}
        setRowsWithErrors={() => {}}
        className='handsontable-confirm-delete'
        readOnly={true}
      />
    </Box>
  );
};
